import { EVSE_NATIVE_APIS } from './constant';



export function requestCameraPermission() {
    window.open(`${EVSE_NATIVE_APIS.STATUS_CAMERA}`, "_self")
}
